import { Icon } from '@wartek-id/icon-v2'
import { Input, InputGroup, InputLeftAddon } from '@wartek-id/input'
import { Shimmer } from '@wartek-id/shimmer'

import type { FC } from 'react'

interface SearchStatusPengirimanProps {
  isLoading?: boolean
  preSearchText: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

export const SearchStatusPengiriman: FC<SearchStatusPengirimanProps> = ({
  isLoading = false,
  preSearchText,
  onChange,
  onKeyDown,
}) => {
  return (
    <div>
      {isLoading ? (
        <Shimmer width={308} height={44} />
      ) : (
        <InputGroup>
          <InputLeftAddon>
            <Icon>search</Icon>
          </InputLeftAddon>
          <Input
            size="md"
            disabled={isLoading}
            placeholder="Ketik nama"
            value={preSearchText}
            className="border-subdued !pr-0"
            onKeyDown={onKeyDown}
            onChange={onChange}
          />
        </InputGroup>
      )}
    </div>
  )
}
